export const TIMEFRAME_LS_KEY = "dbp-top-bar-timeframe";
export const SETTINGS_LS_KEY = "dbp-settings";
